import { PUT_NATIVE_LAT_LONG, RESET_NATIVE_LAT_LONG } from '../actionTypes/NativeAppActionTypes';

const NativeAppLatLongReducer = function NativeAppUserDetailsReducer(state = {}, action) {
    switch (action.type) {
        case RESET_NATIVE_LAT_LONG:
            return {};
        case PUT_NATIVE_LAT_LONG:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

NativeAppLatLongReducer.reducerName = 'NativeAppLatLongReducer';

export default NativeAppLatLongReducer;
